import { Grid2 } from "@mui/material";
import ContainerStyle from "../GraphContainer/containerStyle.module.scss";
const GraphContainer = (props) => {
  const { header, content } = props;
  return (
    <div>
      <Grid2 className={ContainerStyle.sectionContainer}>
        <Grid2 item className={ContainerStyle.header}>
          {header}
        </Grid2>
        <Grid2 className={ContainerStyle.headerLine}></Grid2>
        <Grid2 className={ContainerStyle.content}>{content}</Grid2>
      </Grid2>
    </div>
  );
};

export default GraphContainer;
